<template>
    <div class="bf-box">
         <!-- 底部播放器 -->
         <div class="Song_Player">
            <div class="Tou_img">
                <div class="tu-bian" @click="amplify()">
                    <div class="cover-hei">
                        <img src="../../assets/quanping.png" alt="">
                    </div>
                    <img class="song-cover-img" :src="ceshi.img" alt="">
                </div>
                <div class="wei-zi-text">
                    <div>{{ceshi.name}}</div>
                    <div>{{ceshi.songshou}}</div>
                </div>
            </div>
            <div class="JinduTiao">
                <div class="Control-keys">
                    <div class="t-song" @click="upperSong()">
                        <div class="Tu-wen"><span class="iconfont icon-xiayishou" style="transform: rotate(180deg);"></span></div>
                        <div class="tishi-top">上一首：{{ ceshi.upper }} <img src="../../assets/sanjiao.png" alt=""></div>
                    </div>
                    <div class="b-fang" @click="begins()">
                        <span v-show="songplay==false" class="iconfont icon-bofang" style="margin-left: 6px;"></span>
                        <span v-show="songplay==true" class="iconfont icon-16gf-pause2"></span>
                    </div>
                    <div class="b-song" @click="belowSong()">
                        <div class="Tu-wen"><span class="iconfont icon-xiayishou"></span></div>
                        <div class="tishi-but">下一首：{{ ceshi.below }}<img src="../../assets/sanjiao.png" alt=""></div>
                    </div>
                </div>
                <div class="box-pbar">
                    <p class="bar-p2">{{currents}}</p>
                    <el-slider  class="progress-bar" v-model="value1" :show-tooltip="false" :min="0" :max="max" @change="nozhuai(value1)"></el-slider>
                    <p class="bar-p2">{{Total}}</p>
                </div>
            </div>
            <div class="song_gongNeng">
                <div style="margin-left: 30px;" class="santi-jian" @click="Songsuiji()"><span :style="SuiJishu==1?'color:#409EFF':''" class="iconfont icon-suiji"></span></div>
                <div class="santi-jian" @click="XunhuanSong()"><span class="iconfont icon-24gl-repeatOnce2" :style="SuiJishu==2?'color:#409EFF;font-size: 24px;':'font-size: 24px;'"></span></div>
                <div class="santi-jian">
                    <span v-show="Yinliang==0" class="iconfont icon-24gf-volumeCross" style="font-size: 24px;"></span>
                    <span v-show="Yinliang>=6" class="iconfont icon-24gf-volumeHigh" style="font-size: 24px;"></span>
                    <span v-show="Yinliang<=5 && Yinliang>=1" class="iconfont icon-24gf-volumeMiddle" style="font-size: 24px;"></span>
                </div>
                <el-slider class="volume" v-model="Yinliang" :show-tooltip="false" :min="0" :max="YinliangZong" @change="Volmisu(Yinliang)"></el-slider>
            </div>
        </div>
        <!-- 展开的播放器 -->
         <div class="zhankai-box" :style="[BFplayer==true?{bottom:0,}:{bottom:-100+'vh',}]">
            <div class="zhongtui-ok">
                <!-- 功能 -->
                <div class="gongneng-k">
                    <div style="width: 560px; height: 560px; display: flex; align-items: center; justify-content: center;">
                        <img :class="songplay==false?'Tou-xiang-xiao':'Tou-xiang'" :src="ceshi.img" alt="">
                    </div>
                    <div class="song-neisi">
                        <div class="S-text-x1"><p>{{ceshi.name}}</p><p>{{ ceshi.songshou }}</p></div>
                        <div class="S-text-x2">
                            <p>{{currents}}</p>
                            <el-slider class="SecondGeneration" v-model="value1" :show-tooltip="false" :min="0" :max="max" @change="nozhuai(value1)"></el-slider>
                            <p>{{Total}}</p>
                        </div>
                        <div class="S-gongneng-text">
                            <div class="up-song" @click="upperSong()">
                                <img style="margin-right: 5px;" src="../../assets/xiayishou (2).png" alt="">
                            </div>
                            <div class="play" @click="begins()">
                                <span v-show="songplay==false" class="iconfont icon-bofang" style="margin-left: 3px;"></span>
                                <span v-show="songplay==true" class="iconfont icon-16gf-pause2"></span>
                            </div>
                            <div class="up-song" @click="belowSong()">
                                <img style="transform: rotate(0deg);" src="../../assets/xiayishou (2).png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 歌词 -->
                <div class="ge-ci-list">
                    <ul v-if="this.ceshi.content!=='暂无歌词'" class="ul-song" ref="onterDom">
                        <li class="liTextsong" v-for="(item,index) in conversionSong" :key="index" 
                        :style="[Hindex>=1?{transform:'translateY('+ -(Hindex)*75 +'px)'}:'']" @click="keyPayl(item)">
                            <span :class="Hindex==index?'liTianxuan':''">{{item.lyric}}</span>
                        </li>
                    </ul>
                    <div class="Zanwu_songci" v-else="this.ceshi.content">暂无歌词</div>
                </div>
            </div>
            <div class="GuanBi" @click="amplify()">
                <p class="iconfont icon-youjiantou"></p>
            </div>
            <div class="beijing_zhezhaoce"></div>
            <img class="img_beiji" :src="ceshi.img" alt="">
         </div>
         <audio :src="ceshi.audio_src" ref="player"></audio>
    </div>
</template>
<script>
import axios from 'axios';
import request from '@/request';
export default {
    name:'bofang',
    data(){
        return{
            Hindex:0,//歌词对应的 行 id
            BFplayer:false,//大小播放器的显示/隐藏的-控制器
            value1:0,// 滑块 圆点的位置 (当前运动事件)
            //测试歌曲
            ceshi:{
                id:0,//歌曲id
				name:'把回忆拼好给你',//歌曲名称
                songshou:'cici_',//歌手
				img:require('../../assets/huiyi.jpg'),//封面图
				audio_src:require('../../assets/1593859705.mp3'),// 比加require('../../mius') 不然会报错 找不到资源 
				content:"[ti:把回忆拼好给你-cici_.128][ar:戴立志][al:把回忆拼好给你(新版)][by:krc转qrc工具][offset:0][00:00.00]戴立志 - 把回忆拼好给你-cici_.128[00:00.53]词：童子-T、Shingo.S[00:00.89]曲：童子-T[00:01.03]独自收集两个人之间的回忆[00:04.49]即使每当到这时候我都会哭泣[00:07.99]为何一切[00:09.69]变得如此[00:11.38]无法回到过去[00:21.26]我们都是渺小真实存在[00:24.38]祈愿小世界里不只有挫败[00:27.61]直到遇见你我以为就光明起来[00:30.83]眼睛里看到的都是广袤无垠的大海[00:34.42]有你在的日子里不可能被取代[00:37.64]在最灰暗的日子你陪着我发呆[00:40.87]你让我学会如何拨开阴霾[00:43.62]将快乐全部收集将不开心全都淘汰[00:46.43]你对我说的情话[00:49.36]像转瞬即逝的烟花[00:52.59]只停在绽放一刹那[00:55.77]我却已无法自拔[00:58.97]我们的爱总有时差[01:02.20]也为你骗自己放下[01:05.35]爱炙热的你却忘了爱自己[01:12.79]和你在一起画面一帧帧唤醒脑海[01:16.04]你总说我是小孩对我总是想溺爱[01:19.26]我像做了一场梦梦见我们的未来[01:22.45]我们俩嬉嬉闹闹直到梦突然醒来[01:25.64]想和你说声谢谢至少笑着离开[01:28.62]不想闹的不愉快互相不理不睬[01:32.06]我想说爱这件事总要履行告白[01:35.26]最后就用朋友身份说拜拜[01:51.26]有你在的日子里不可能被取代[01:54.43]在最灰暗的日子你陪着我发呆[01:57.70]你让我学会如何拨开阴霾[02:00.42]将快乐全部收集将不开心全都淘汰[02:03.25]你对我说的情话[02:06.14]像转瞬即逝的烟花[02:09.38]只停在绽放一刹那[02:12.58]我却已无法自拔[02:15.83]我们的爱总有时差[02:19.01]也为你骗自己放下[02:22.23]爱炙热的你却忘了爱自己[02:29.07]独自收集两个人之间的回忆[02:32.25]即使每当到这时候我都会哭泣[02:35.43]为何一切[02:37.04]变得如此[02:38.60]无法回到过去[02:41.80]但我仍愿意感谢你给过我爱情[02:45.03]每一场风景都是我们爱的证明[02:48.22]就算如今天各一方[02:51.41]祝你余生动听啊[02:54.24]你对我说的情话[02:57.34]像转瞬即逝的烟花[03:00.57]只停在绽放一刹那[03:03.80]我早已无法自拔[03:06.98]我们的爱总有时差[03:10.20]也为你骗自己放下[03:13.44]爱炙热的你却忘了爱自己",
                upper:'一路生花',//上一首
                below:'倒数'//下一首
            },
            songplay:false, //控制 播放/暂停的属性值 为假-暂停播放 为真-开始播放
            timer:'',//监听器-滑块的
            timerCi:'',//监听器-歌词的
            currents:'00:00',//当前运动时间
            Total:'00:00',//总时间
            max:100,//滑块的最大值 根据歌曲总时间来定
            conversionSong:[],//转化后的歌词
            Yinliang:9,//音量滑块 的圆点位置（当前运动事件）
            YinliangZong:10,//音量的路程的总值
            SuiJishu:0,//是否开启随机数 2 循环  1 随机 0 顺序
        }
    },
    created() {
        //在组件创建时添加键盘事件监听
        window.addEventListener('keyup', this.handleKeyUp);
    },
    
    methods:{
        // 组合键监听
        handleKeyUp(e){
            // Space 播放暂停
            if(e.ctrlKey && e.keyCode==32){
                if(this.songplay){
                    this.pauseSong();//调用暂停
                }else{
                    this.playSong();//调用播放
                }
            }
             // ctrl+右箭头 上一首
            if(e.ctrlKey && e.keyCode==37){
                // console.log('上一首');
                this.upperSong();
            }
            // ctrl+左箭头 下一首
            if(e.ctrlKey && e.keyCode==39){
                // console.log('下一首');
                this.belowSong()
            }
            // ctrl+上箭头 增加音量
            if(e.ctrlKey && e.keyCode==38){
                if(this.Yinliang < 10){
                    this.Yinliang = this.Yinliang + 1;
                    console.log(this.Yinliang);
                    this.$refs.player.volume=this.Yinliang/this.YinliangZong;
                }else{
                    console.log("请不要设置成静音")
                }
            }
            // ctrl+下箭头 减少音量
            if(e.ctrlKey && e.keyCode==40){
                if(this.Yinliang !== 0){
                    this.Yinliang = this.Yinliang - 1;
                    console.log(this.Yinliang);
                    this.$refs.player.volume=this.Yinliang/this.YinliangZong;
                }else{
                    console.log("请设置成静音")
                }
            }
            // ctrl+k 打开搜索
            if(e.ctrlKey && e.keyCode==81){
                this.$router.push('/sousuo')
            }
            // Esc 关闭歌词
            if(e.keyCode==27){
                if(this.$store.state.BottomPlayer==true){
                    this.amplify();
                }else{
                    this.$store.state.BottomPlayer=true;
                }
                
            }
        },
        //放大播放器
        amplify(){
            if(this.BFplayer){
                this.BFplayer = false;
                
            }else{
                this.BFplayer = true;
                this.Jsongeci();
            }
        },
        //请求方法
        async requestSong(index){
            console.log(index);
            const [isSuccess, data,] = await request({
                url:'api/index/bofang',
                params:{
                    gequid:index,
                }
            });
            if(isSuccess){
                console.log(data);
                this.ceshi.id = data.data.id;
                this.ceshi.name = data.data.names;
                this.ceshi.songshou = data.data.xingming;
                this.ceshi.img = data.data.music_image;
                this.ceshi.content = data.data.music_lrc;
                this.ceshi.audio_src = data.data.music_url;
                this.ceshi.upper = data.data.shang;
                this.ceshi.below = data.data.xia;
                setTimeout(()=>{
                    clearInterval(this.timer);//删除 监听器 滑块的
                    clearInterval(this.timerCi);// 删除 监听器 歌词的
                    this.playSong();
                    if(this.$store.state.LoginStatus!==''){
                        const data = {
                        gequids: this.ceshi.id,
                        phones:this.$store.state.LoginStatus.phone,
                        } 
                        console.log(data)
                        axios.post('api/index/zuijin',data)
                        .then(response => {
                            // 处理请求成功的响应
                            console.log(response.data);
                        })
                        .catch(error => {
                            // 处理请求失败的错误
                            console.error(error);
                        });
                    }
                },500);
            }else{
                console.log(isSuccess)
            }
        },
        //播放歌曲
        begins(){
            if(this.songplay){
                this.pauseSong();//调用暂停
            }else{
                this.playSong();//调用播放
            }
        },
        //歌曲播放功能
        playSong(){
            this.$refs.player.play();//播放
            this.songplay = true;//图标改成播放状态
            this.timer = setInterval(this.progressSlider,500);//监听器 进度条的滚动
            this.Total =  this.Henshin(this.$refs.player.duration);//总时间 转换的总时间 复制
            this.max = ~~(this.$refs.player.duration);//进度条最大 值
            this.Jsongeci();//歌词转换
            this.songci(); //调用歌词滚动
            //el 右上角提示框
            this.$notify({
                title:this.ceshi.name,
                message:this.ceshi.songshou,
                duration:1500
            });
        },
        //歌曲暂停功能
        pauseSong(){
            this.$refs.player.pause();//暂停
            this.songplay = false;//图标改成暂停状态
            clearInterval(this.timer);//删除 监听器 滑块的
            clearInterval(this.timerCi);// 删除 监听器 歌词的
        },
        //上一首
        upperSong(){
            if(this.ceshi.id<=1){
                this.ceshi.id=198;
                console.log(this.ceshi.id);
            }
            this.requestSong(this.ceshi.id-1);
        },
        //下一首
        belowSong(){
            if(this.ceshi.id>=197){
                this.ceshi.id=0;
                console.log(this.ceshi.id);
            }
            if(this.SuiJishu==0){
                this.requestSong(this.ceshi.id+1);
            }else if(this.SuiJishu==1){
                let indSui =  Math.floor(Math.random() * (1 - 197 + 1)) + 1;
                //负负得正
                this.requestSong(indSui*-1);
            }else{
                this.requestSong(this.ceshi.id);
            }
            
        },
        //歌曲随机
        Songsuiji(){
            //是否开启随机数 2 循环  1 随机 0 顺序
            if(this.SuiJishu==2 || this.SuiJishu==0){
                this.SuiJishu=1;
            }else{
                this.SuiJishu=0;
            }
        },
        //循环歌曲
        XunhuanSong(){
             //是否开启随机数 2 循环  1 随机 0 顺序
            if(this.SuiJishu==1 || this.SuiJishu==0){
                this.SuiJishu=2;
            }else{
                this.SuiJishu=0;
            }
        },
        //进度条 变动
        progressSlider(){
            this.value1 = ~~(this.$refs.player.currentTime);//滑块点的 数值
            console.log(this.value1);
            this.currents =  this.Henshin(this.$refs.player.currentTime);//当前运动的时间
            if(this.value1>=this.max){
                clearInterval(this.timer);
                clearInterval(this.timerCi);
                this.songplay = false;
                console.log('下一首');
                this.belowSong();
            }
        },
        //拖拽 滑块
        nozhuai(e){
            console.log(e);
            this.$refs.player.currentTime = e;
        },
        //歌词转换
        Jsongeci() {
            this.conversionSong = [];
            let re = /\[([^\]]+)\]([^\[]+)/g; // eslint-disable-line
            this.ceshi.content.replace(re, ($0, $1, $2) => {
                this.conversionSong.push({
                    "time": this.geci($1),
                    "lyric": $2
                });
                //filter() 过滤 也可以用来搜索  filter一共有三个值 第一个当前遍历的数组项 第二个索引值 第三个调用filter函数的数组本身
                //filter() 方法用于过滤数组中的元素，并返回一个新数组。
                this.conversionSong = this.conversionSong.filter((item) => {
                    return item.time != "NaN" //过滤数组中的item.item != "NaN" 就是没有时间的，不要
                });
                this.conversionSong = this.conversionSong.filter((item) => {
                    return item.lyric !== '\n'//过滤数组中的item.lyric != "NaN" 就是没有歌词的，不要
                });
               
            });
        },
        // 把歌词的时间转换秒
        geci(value) {
            let arr = value.split(':'); //split() 分割字符
            return (Number(arr[0] * 60) + Number(arr[1])).toFixed(1); //toFixed 后面小数显示1位
        },
        //歌词滚动
        songci(){
            this.timerCi = setInterval(() => {
                for (let i = 0; i < this.conversionSong.length; i++) {
                    //这个判断是 有没有结束  当前时间 大于 歌词的秒数 （为什么要减一 就是不让他继续再往下高亮了 因为下面加一了）
                    if (this.$refs.player.currentTime > this.conversionSong[this.conversionSong.length - 1].time) {
                        this.Hindex = this.conversionSong.length - 1;
                        console.log(this.Hindex);
                        break;
                    }
                    //判断 歌词高亮 当前时间大于listLrc歌词时间 && 当前时间小于歌词时间 （加一 是为了 让当前时间大于歌词时间并且小于歌词时间 加在中间）
                    if (this.$refs.player.currentTime> this.conversionSong[i].time && this.$refs.player.currentTime < this.conversionSong[i + 1].time) {
                        this.Hindex = i;
                        console.log(this.Hindex);
                    }

                }

            }, 800);
        },
        //点击歌词跳转对应的事件点
        keyPayl(e){
            // console.log(e.time);
            this.$refs.player.currentTime = e.time;
            this.$refs.onterDom.scrollTop = 0;
            //如果当前是为播放状态 点击歌词 就播放歌曲
            if(this.songplay==false){this.playSong()}
        },
        //把时间转换成 MM:SS格式
        Henshin(times) {
			let minute = Math.floor(times / 60);
			let rest_seconds = Math.floor(times % 60);
			//return 返回给 MMSS格式
			return minute.toString().padStart(2, '0') + ':' + rest_seconds.toString().padStart(2, '0');
		},
        //控制音量
        Volmisu(e){
            // volume 的取值范围 0-1 所以让 1除以10 等于 0.1
            this.$refs.player.volume=e/this.YinliangZong;
        },
        
    },
    // 计算属性
    computed:{
        status(){
            return this.$store.state.SongId;
        }
    },
    // 监视属性
    watch:{
        status(){
            this.requestSong(this.$store.state.SongId);
        }
    }
    // 使用vuex  进行组件的传参 以及使用计算属性和监视属性 触发 组件中的方法 实现 点击a组件 b组件中的方法被调用 从而实现歌曲播放 
}
</script>
<style lang="scss">
//播放器
.Song_Player{
    width: 100%;
    height: 102px;
    position: absolute;
    z-index: 50;
    bottom: 0;
    border-top: solid 1px var(--buttom-border-top);
    background-color: var(--buttom-background);
    backdrop-filter:blur(15px);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .Tou_img{
        width: 500px;
        height: 70px;
        margin-left: 25px;
        display: flex;
        align-items: center;
        
        .tu-bian{
            width: 70px;
            height: 70px;
            overflow: hidden;
            position: relative;
            border-radius: 5px;
            cursor: pointer;
            margin-right: 17px;
            .cover-hei{
                width: 100%;
                height: 100%;
                position: absolute;
                z-index: 1;
                background-color: rgba(0, 0, 0, 0.3);
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transition: 0.2s;
            }
            .song-cover-img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .tu-bian:hover .cover-hei{
            opacity: 1;
            transition: 0.2s;
        }
        .wei-zi-text{
            height: 45px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            div:nth-child(1){
                font-size: var(--buttom-song-tlite-size);
                font-weight: bold;
                font-family: YuanTi;
                cursor: pointer;
                color: var(--them-color);
            }
            div:nth-child(2){
                font-size: var(--nav-songTlite-fsize);
                font-family: YuanTi;
                cursor: pointer;
                color: var(--them-color);
            }
        }
    }
    .JinduTiao{
        width: 780px;
        height: 85px;
        display: flex;
        flex-direction: column;
        // background-color: aqua;
        justify-content: space-around;
        .Control-keys{
            width: 100%;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .t-song{
                width: 42%;
                height: 60px;
                // background-color: #3c3c3c;
                position: relative;
               
                display: flex;
                align-items: center;
                .tishi-top{
                    height: 30px;
                    background-color: var(--paly-top-background);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: var(--nav-text-fsize);
                    padding: 0px 10px;
                    font-family: YaunTi;
                    border-radius: 3px;
                    cursor: pointer;
                    position: relative;
                    color:#fff;
                    position: absolute;
                    right: 35px;
                    transition: 0.2s;
                    transform: scale(0.5);
                    opacity: 0;
                    img{
                        width: 12px;
                        height: 15px;
                        position: absolute;
                        transform: rotate(150deg);
                        top: 5px;
                        right: -6px;
                    }
                }
                .Tu-wen{
                    width: 50px;
                    height: 50px;
                    position: absolute;
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content:center;
                    cursor: pointer;
                    right: 0;
                    transition: 0.2s;
                    span{
                        font-size: var(--nav-text-fsize30);
                        color: var(--them-color);
                    }
                }
                .Tu-wen:hover{
                    transition: 0.2s;
                    background-color: var(--buttom-Bf-color);
                }
                .Tu-wen:hover + .tishi-top{
                    transition: 0.2s;
                    opacity: 1;
                    transform: scale(1);
                    right: 70px;
                }
            }
            .b-fang{
                width: 55px;
                height: 55px;
                display: flex;
                align-items: center;
                justify-content:center;
                border-radius: 20px;
                cursor: pointer;
                transition: 0.2s;
                display: flex;
                align-items: center;
                justify-content: center;
                span{
                    font-size: 35px;
                    color: var(--them-color);
                }
            }
            .b-fang:hover{
                transition: 0.2s;
                background-color: var(--buttom-Bf-color);
            }
            .b-song{
                width: 42%;
                height: 60px;
                position: relative;
                display: flex;
                align-items: center;
                .Tu-wen{
                    width: 50px;
                    height: 50px;
                    position: absolute;
                    border-radius: 16px;
                    display: flex;
                    align-items: center;
                    justify-content:center;
                    cursor: pointer;
                    left: 0;
                    transition: 0.2s;
                    span{
                        font-size: var(--nav-text-fsize30);
                        color: var(--them-color);
                    }
                }
                .Tu-wen:hover{
                    transition: 0.2s;
                    background-color: var(--buttom-Bf-color);
                }
                .tishi-but{
                    height: 30px;
                    background-color: var(--paly-top-background);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: var(--nav-text-fsize);
                    padding: 0px 10px;
                    font-family: YaunTi;
                    border-radius: 3px;
                    cursor: pointer;
                    position: relative;
                    color:#fff;
                    position: absolute;
                    left: 35px;
                    transition: 0.2s;
                    transform: scale(0.5);
                    opacity: 0;
                    img{
                        width: 12px;
                        height: 15px;
                        position: absolute;
                        transform: rotate(215deg);
                        top: 5px;
                        left: -6px;
                    }
                }
                .Tu-wen:hover + .tishi-but{
                    transition: 0.2s;
                    opacity: 1;
                    transform: scale(1);
                    left: 70px;
                }
            }
            
        }
        .box-pbar{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .bar-p2{
                font-size: var(--nav-text-fsize12);
                font-family: YuanTi;
                color: var(--them-color);
                font-weight: bold;
            }
            .bar-p2{
                font-size: var(--nav-text-fsize12);
                font-family: YuanTi;
                color: var(--them-color);
                font-weight: bold;
            }
            .progress-bar{
                width: 87%;
                // appearance: none;
                // background-color: var(--buttom-range-background);
                // border-radius: 50px;
                // height: 9px;
                cursor: pointer;
            }
        }
    }
    .song_gongNeng{
        width:280;
        height: 65px;
        margin-right: 100px;
        display: flex;
        align-items: flex-end;
        .santi-jian{
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-left:13px;
            border-radius: 10px;
            cursor: pointer;
            transition: 0.2s;
            span{
                font-size: var(--nav-text-fsize19);
                color: var(--them-color);
            }
        }
        .santi-jian:hover{
            background-color: var(--buttom-Bf-color);
            transition: 0.2s;
        }
        .volume{
            width: 70px;
            border-radius: 6px;
            margin-left: 25px;
        }
    }
}
// 展开
.zhankai-box{
    width: 100%;
    height: 100vh; 
    background-image: linear-gradient(330deg,rgb(0, 0, 0),rgb(0, 56, 43));
    position: absolute;
    z-index: 90;
    bottom: -100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.3s;
    // z-index: -1;
    .zhongtui-ok{
        width: 1400px;
        height: 80%;
        // border: solid 1px #fff;
        position: absolute;
        z-index: 55;
        display: flex;
        align-items: center;
        justify-content: space-around;
        .gongneng-k{
            width: 580px;
            height: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            .Tou-xiang{
                width: 550px;
                height: 550px;
                border-radius: 15px;
                box-shadow: 0 0 20px 0 #303030;
                transition: 0.2s;
                object-fit: cover;
            }
            .Tou-xiang-xiao{
                width: 460px;
                height: 460px;
                border-radius: 15px;
                box-shadow: 0 0 20px 0 #2c2c2c;
                transition: 0.2s;
                object-fit: cover;
            }
            .song-neisi{
                width: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                margin-top:30px;
                .S-text-x1{
                    width: 100%;
                   p:nth-child(1){
                    font-size:20px;
                    color: #fff;
                    font-weight: bold;
                    font-family: YuanTi;
                   } 
                   p:nth-child(2){
                    font-size:16px;
                    color: #d4d4d4;
                    // font-weight: bold;
                    font-family: YuanTi;
                    margin-top: 9px;
                   } 
                }
                .S-text-x2{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-top: 20px;
                    color: #fff;
                    font-size: 13px;
                    font-family: YuanTi; 
                    .SecondGeneration{
                        width: 83%;
                        cursor: pointer;
                    }
                }
                .S-gongneng-text{
                    width:170px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .up-song{
                        width: 50px;
                        height: 50px;
                        border-radius: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        transition: 0.2s;
                        img{
                            width: 50%;
                            height: 50%;
                            object-fit: cover;
                            transform: rotate(180deg);
                            margin-left: 3px;
                        }
                    }
                    .up-song:hover{
                        transition: 0.2s;
                        background-color: rgba(199, 199, 199, 0.2);
                    }
                    .play{
                        width: 55px;
                        height: 55px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        text-align: center;
                        border-radius: 15px;
                        cursor: pointer;
                        transition: 0.2s;
                        span{
                            font-size: 33px;
                            color: #fff;
                        }
                    }
                    .play:hover{
                        transition: 0.2s;
                        background-color: rgba(199, 199, 199, 0.2);
                    }
                }
            }
        }
        .ge-ci-list{
            mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 32%),
            linear-gradient(to top, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 1) 32%);//合成
            width: 720px;
            height: 100vh;
            // background-color: #fff;
            mask-composite: intersect;
            // mask-composite: intersect 用于指定多个遮罩图层如何组合。当使用intersect值时，只有当所有遮罩图层在相同位置都是不透明的区域才会在最终结果中显示为不透明，其余部分都会变成透明。这可以用来创建遮罩的交集效果‌
            .Zanwu_songci{
                color: #fff;
                font-size: 25px;
                top:50%;
                position: relative;
                font-weight: bold;
                left: 40%;
            }
            .ul-song{
                width: 100%;
                height: 80vh;
                overflow: hidden;
                overflow-y: auto;
                display: flex;
                flex-direction: column;
                padding-top: 372px;
                &::-webkit-scrollbar {
                display: none; /* Chrome Safari */
                }
                .liTextsong{
                    font-size: 23px;
                    color: #afafaf;
                    height: 75px;
                    line-height: 75px;
                    padding-left: 25px;
                    cursor: pointer;
                    transition: 0.2s;
                    border-radius: 15px;
                }
                .liTextsong:hover{
                    background-color: rgba(236, 236, 236, 0.2);
                    transition: 0.2s;
                }
                .liTianxuan{
                    color: #ffffff;
                    font-size: 26px;
                    font-weight: bold;
                }
            }
            
        }
        
    }

    .GuanBi{
        position: absolute;
        right: 40px;
        top: 40px;
        width: 60px;
        height: 60px;
        border-radius: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 100;
        p{
            font-size: 20px;
            font-weight: bold;
            transform: rotate(90deg);
            color: #bbbbbb;
        }
    }
    .GuanBi:hover{
        background-color: rgba(103, 103, 103, 0.3);
        p{
            font-size: 20px;
            font-weight: bold;
            transform: rotate(90deg);

            
            color: #fff;
        }
    }
    .img_beiji{
        width: 100%;
        height: 80%;
        overflow: hidden;
        object-fit: cover;
        position: absolute;
        z-index: 1;
        filter: blur(60px);
    }
    .beijing_zhezhaoce{
        width: 100%;
        height: 100%;
        position: absolute;
        background-color: rgba(24, 24, 24, 0.3);
        z-index: 2;
    }
}

// elent
.el-slider__button{
    width: 12px !important;
    height: 12px!important;
}

</style>